const CovidCoverage =Object.freeze([
  { key: 1, value: 2000 },
  { key: 3, value: 30000},
]);
  
export default CovidCoverage;